<template>
    <div>
        <div class="card">
            <div class="card-header">Compose</div>
            <div class="card-body">
                <validation-observer ref="observer" v-slot="{ passes }">
                    <b-form @submit.stop.prevent="passes(sendMessage)">
                        <b-form-group label="Email:" label-for="customer" label-cols-sm="4"
                                      label-cols-lg="3"
                                      content-cols-sm
                                      content-cols-lg="7">
                            <validation-provider name="Email" rules="required|email" v-slot="{ errors }">
                                <b-form-input v-model="customer" id="customer" placeholder="Enter customer email"></b-form-input>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <b-form-group label="Mailbox:" label-for="channelSelect" label-cols-sm="4"
                                      label-cols-lg="3"
                                      content-cols-sm
                                      content-cols-lg="7">
                            <validation-provider name="Mailbox" rules="required" v-slot="{ errors }">
                                <b-form-select v-model="selectedChannel" id="channelSelect">
                                    <option value="">Select Channel</option>
                                    <option v-for="channel in channels" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
                                </b-form-select>
                                <span class="validation">{{ errors[0] }}</span>
                            </validation-provider>
                        </b-form-group>

                        <template v-if="!proposalStatus">
                            <b-form-group label="Outline:" label-for="outlineInput">
                                <b-input-group>
                                    <b-form-input v-model="promptInput" id="outlineInput" placeholder="Ask about their experience with..."></b-form-input>
                                    <template #append>
                                        <b-form-select v-model="language">
                                            <option v-for="languageName in languages" :key="languageName" :value="languageName">{{ languageName }}</option>
                                        </b-form-select>
                                    </template>
                                </b-input-group>
                            </b-form-group>

                            <b-button variant="outline" @click="skipProposal()">Skip</b-button>
                            <b-button variant="primary" @click="proposeNew()">AI Generate</b-button>
                        </template>
                        <template v-else>
                            <div v-if="proposalStatus === 'loading'" class="text-center pt-3">
                                <b-spinner></b-spinner>
                                <p>{{ randomLoadingText }}</p>
                                <b-button variant="outline" class="btn-sm" @click="skipProposal()">Skip AI</b-button>
                            </div>
                            <template v-else>
                                <b-form-group label="Subject:" label-for="subjectInput">
                                    <validation-provider name="Subject" rules="required" v-slot="{ errors }">
                                        <b-form-input v-model="subject" id="subjectInput" placeholder="Enter email subject"></b-form-input>
                                        <span class="validation">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-form-group label="Message:" label-for="messageEditor">
                                    <validation-provider name="Message" rules="required" v-slot="{ errors }">
                                        <vue-editor v-model="message" id="messageEditor" :editor-toolbar="customEditorToolbar"></vue-editor>
                                        <span class="validation">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-form-group>

                                <b-button type="submit" variant="primary" :disabled="sending">
                                    <b-spinner small v-if="sending"></b-spinner>
                                    Send
                                </b-button>
                            </template>
                        </template>
                    </b-form>
                </validation-observer>
            </div>
        </div>
    </div>
</template>


<script>
import { VueEditor } from "vue2-editor";
import NotificationPop
    from "../mixins/NotificationPop";

export default {
    components: { VueEditor },
    mixins: [NotificationPop],
    data() {
        return {
            customEditorToolbar: [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
            ],
            loadingTexts: [
                "Training our AI to craft the perfect reply...",
                "Harnessing the power of AI for your reply...",
                "Engaging our AI assistants to write a clever response...",
                "Assembling the neural networks to compose your reply...",
                "Loading AI creativity module for responses...",
                "Unlocking the AI's sense of humor for your reply...",
                "Processing AI algorithms to generate a clever reply...",
                "Waiting for the AI to concoct the perfect response...",
                "Using AI magic to craft a reply...",
                "Empowering our AI to send a message...",
                "Utilizing the brilliance of AI for a reply...",
                "Relying on AI's sense of urgency for your reply...",
                "Unleashing the AI's wit for a clever response...",
                "Leveraging AI brainpower to compose a reply...",
                "Syncing with AI for an intelligent message...",
                "Bringing the AI some coffee...",
                "Doing yoga with the AI...",
            ],
            randomLoadingText: "",

            "languages": [
                "Akan",
                "Amharic",
                "Arabic",
                "Assamese",
                "Azerbaijani",
                "Awadhi",
                "Bengali",
                "Bhojpuri",
                "Burmese",
                "Cebuano",
                "Chewa",
                "Chhattisgarhi",
                "Chittagonian",
                "Czech",
                "Dhundhari",
                "Deccan",
                "Dutch",
                "English",
                "Fula",
                "French",
                "Gan Chinese",
                "German",
                "Greek",
                "Greek Sign Language",
                "Gujarati",
                "Haitian Creole",
                "Hakka Chinese",
                "Haryanvi",
                "Hausa",
                "Hebrew",
                "Hindi",
                "Hungarian",
                "Indonesian",
                "Italian",
                "Japanese",
                "Javanese",
                "Kannada",
                "Kazakh",
                "Khmer",
                "Kinyarwanda",
                "Kirundi",
                "Korean",
                "Korean Sign Language",
                "Kurdish",
                "Lao",
                "Magadhi",
                "Magahi",
                "Maithili",
                "Malagasy",
                "Malayalam",
                "Mandarin Chinese",
                "Marathi",
                "Marwari",
                "Min Dong Chinese",
                "Nepali",
                "Northern Sotho",
                "Odia",
                "Oromo",
                "Pashto",
                "Persian",
                "Polish",
                "Portuguese",
                "Punjabi",
                "Romanian",
                "Russian",
                "Saraiki",
                "Serbian",
                "Serbo-Croatian",
                "Shona",
                "Sindhi",
                "Sinhala",
                "Somali",
                "South Azerbaijani",
                "Spanish",
                "Standard Arabic",
                "Sundanese",
                "Sylheti",
                "Swahili",
                "Tagalog",
                "Tamil",
                "Telugu",
                "Thai",
                "Turkish",
                "Ukrainian",
                "Urdu",
                "Uzbek",
                "Vietnamese",
                "Xiang Chinese",
                "Yoruba",
                "Yue Chinese",
                "Zhuang",
                "Zulu"
            ],


            selectedChannel: '',
            channels: [],
            message: '',
            customer: '',
            subject: '',
            promptInput: '',
            proposalStatus: null,
            sending: false,
            language: 'English',
        };
    },
    mounted() {
        // Start the interval to change the loading text every 2 seconds
        this.randomLoadingText = this.getRandomLoadingText();
        setInterval(() => {
            this.randomLoadingText = this.getRandomLoadingText();
        }, (1000 * 2));

        // Fetch channels data from API
        this.fetchChannels();
    },
    methods: {

        getRandomLoadingText() {
            const randomIndex = Math.floor(Math.random() * this.loadingTexts.length);
            return this.loadingTexts[randomIndex];
        },
        skipProposal() {
            this.proposalStatus = 'skipped'
        },
        proposeNew(threadId) {
            if(!this.selectedChannel || !this.promptInput) {
                alert('Choose a mailbox and enter a prompt first');
                return;
            }

            this.proposalStatus = 'loading';

            // Make a POST request to the proposeReply endpoint
            this.$http.post(`channels/${this.selectedChannel}/propose-new`, {language: this.language, prompt_input: this.promptInput})
                .then(response => {
                    this.message = this.message + response.data.proposal;
                    this.subject = this.subject + response.data.proposal_subject;
                    this.proposalStatus = 'generated'
                })
                .catch(error => {
                    console.error(error);
                    this.popNotification('Cannot propose an email. Please contact support and skip', 'danger')
                    // Handle any errors that occurred during the request
                });
        },


        fetchChannels() {
            this.$http
                .get('channels')
                .then(response => {
                    this.channels = response.data.data;
                })
                .catch(error => {
                    console.error('Error fetching channels', error);
                    this.popNotification('Cannot load page. Please contact support', 'danger')
                });
        },
        sendMessage() {
            this.sending = true

            this.$http
                .post('channels/' + this.selectedChannel + '/post-message', {
                    customer_identifier: this.customer,
                    message: this.message,
                    subject: this.subject,
                })
                .then(response => {
                    console.log('Message sent successfully');
                    // Clear the selected channel and message fields
                    this.selectedChannel = '';
                    this.customer = '';
                    this.message = '';
                    this.subject = '';
                    this.popNotification('Message sent', 'success')
                    this.$refs.observer.reset();
                    this.sending = false
                })
                .catch(error => {
                    console.error('Error sending message', error);
                    this.popNotification('Could not send your message', 'danger')
                });
        },
    },
};
</script>

<style scoped>
</style>
